// Current active integrations allowed in the system
export enum ActiveIntegrations {
    indeed = 'indeed',
    greenhouse = 'greenhouse',
    workable = 'workable',
    xero = 'xero',
    zapier = 'zapier',
    linkedin = 'linkedin',
}
